import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

interface ComparisonFeature {
  category: string;
  features: {
    name: string;
    capawesome: boolean | string;
    appflow: boolean | string;
    capawesomeAdvantage?: boolean;
  }[];
}

@Component({
  selector: 'app-compare-ionic-appflow-table-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './compare-ionic-appflow-table-section.component.html',
  styleUrl: './compare-ionic-appflow-table-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareIonicAppflowTableSectionComponent {
  protected readonly comparisonData: ComparisonFeature[] = [
    {
      category: 'Pricing',
      features: [
        {
          name: 'Starting Price',
          capawesome: '$9/month',
          appflow: '$49/month',
          capawesomeAdvantage: true,
        },
        {
          name: 'Cost per MAU (Live Updates)',
          capawesome: '~$0.001',
          appflow: '~$0.01',
          capawesomeAdvantage: true,
        },
        {
          name: 'Free Tier',
          capawesome: 'Yes',
          appflow: 'Limited',
          capawesomeAdvantage: true,
        },
      ],
    },
    {
      category: 'Platform Status',
      features: [
        {
          name: 'New Customer Sales',
          capawesome: 'Active',
          appflow: 'Discontinued',
          capawesomeAdvantage: true,
        },
        {
          name: 'Long-term Support',
          capawesome: 'Committed',
          appflow: 'Until Dec 2027',
          capawesomeAdvantage: true,
        },
        {
          name: 'Future Development',
          capawesome: 'Active',
          appflow: 'No new features',
          capawesomeAdvantage: true,
        },
      ],
    },
    {
      category: 'Features',
      features: [
        {
          name: 'Live Updates',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Native iOS/Android Builds',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'App Store Publishing',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Code Signing',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Delta Updates',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Automatic Rollbacks',
          capawesome: true,
          appflow: false,
          capawesomeAdvantage: true,
        },
        {
          name: 'Channel Support',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'CLI Support',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'API Access',
          capawesome: true,
          appflow: true,
        },
      ],
    },
    {
      category: 'Native Builds',
      features: [
        {
          name: 'Build Infrastructure',
          capawesome: 'M4 macOS runners',
          appflow: 'M1 macOS runners',
          capawesomeAdvantage: true,
        },
        {
          name: 'Build Speed',
          capawesome: '3-5x faster',
          appflow: 'Standard',
          capawesomeAdvantage: true,
        },
        {
          name: 'Git Integration',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Signing & Provisioning',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Custom Build Commands',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Monorepo Support',
          capawesome: true,
          appflow: true,
        },
      ],
    },
    {
      category: 'App Store Publishing',
      features: [
        {
          name: 'TestFlight Submission',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'App Store Submission',
          capawesome: true,
          appflow: true,
        },
        {
          name: 'Google Play Submission',
          capawesome: true,
          appflow: true,
        },
      ],
    },
    {
      category: 'Security & Privacy',
      features: [
        {
          name: 'Open Source SDK (Live Updates)',
          capawesome: true,
          appflow: false,
          capawesomeAdvantage: true,
        },
        {
          name: 'Open Source CLI',
          capawesome: true,
          appflow: false,
          capawesomeAdvantage: true,
        },
        {
          name: 'Zero-trust Architecture',
          capawesome: true,
          appflow: true,
          capawesomeAdvantage: true,
        },
        {
          name: 'EU Hosting Option',
          capawesome: true,
          appflow: false,
          capawesomeAdvantage: true,
        },
      ],
    },
    {
      category: 'Support & Focus',
      features: [
        {
          name: 'Migration Support',
          capawesome: 'Full support',
          appflow: 'Limited',
          capawesomeAdvantage: true,
        },
        {
          name: 'Community & Documentation',
          capawesome: 'Active',
          appflow: 'Maintenance mode',
          capawesomeAdvantage: true,
        },
      ],
    },
  ];
}
